import Plans from './containers/Plans';

export default Plans;
